// extracted by mini-css-extract-plugin
export var attachment = "_ny-a";
export var emailContainer = "_ny-4";
export var emailContentPaddedContainer = "_ny-b";
export var emailHeader = "_ny-6";
export var emailIframe = "_ny-3";
export var emailInfoIcon = "_ny-9";
export var emailShortenedSummary = "_ny-e";
export var infoDropdown = "_ny-0";
export var infoRowBoundedContent = "_ny-d";
export var internal = "_ny-5";
export var merchant = "_ny-8";
export var messageInputContainer = "_ny-h";
export var normal = "_ny-7";
export var replyCard = "_ny-f";
export var subtleButton = "_ny-1";
export var subtleButtonIconContainer = "_ny-2";
export var toggleViewRepliesButton = "_ny-c";
export var wrappingText = "_ny-g";